module.exports = __webpack_public_path__ + "static/the-double-helix-653e4c13371ff74ba21b35a131a7cf9a.jpg";